import { inject, injectWithTransform, singleton } from "tsyringe";
import { Logger, LoggerTransformer } from "@identity/utils";
import { AdTargetingService } from "../AdTargetingService";
import { PartnersService } from "../partners";

@singleton()
export class TargetingService {
  constructor(
    @inject(PartnersService)
    private partnersService: PartnersService,
    @inject(AdTargetingService)
    private adTargetingGroups: AdTargetingService,
    @injectWithTransform(Logger, LoggerTransformer, "TargetingService")
    private readonly logger: Logger,
  ) {}

  async initializeTargeting() {
    this.logger.info("Setting up targeting");
    await this.partnersService.initializeTargetingPartners();
    this.adTargetingGroups.init();
  }
}
